import { render, staticRenderFns } from "./CreateBooking.vue?vue&type=template&id=57165ced&scoped=true&lang=html"
import script from "./CreateBooking.vue?vue&type=script&lang=js"
export * from "./CreateBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57165ced",
  null
  
)

export default component.exports